import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=4cade1ba"
import script from "./purchased.vue?vue&type=script&lang=js"
export * from "./purchased.vue?vue&type=script&lang=js"
import style0 from "./purchased.vue?vue&type=style&index=0&id=4cade1ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports